import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from 'react-redux';
import {
  UpdateGarageListing,
  getCarBrand,
  getGarageCategory,
  getGarageServices,
  deleteService,
  getGarageDataWFilter,
  addGarageService,
  updateGarageService,
} from './../../../../Redux/Actions/UserAction';
import Sidebar from '../../../common/Sidebar/Sidebar';
import { BorderColorOutlined } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { CommonBusinessHeader } from '../CommonBusinessHeader';
import Swal from 'sweetalert2';

const GaragesServices = () => {
  const { t, i18n } = useTranslation();
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  // Bilingual category label from the data: Arabic (`category`) in Arabic mode,
  // English (`categoryEn`) in English mode — managed by admins.
  const catLabel = (cat, catEn) =>
    isRTL ? cat || catEn : catEn || cat;
  /* [CF 2026-08-17] Brand chips read `name || nameAr`, which is English-first
     whatever the site language — so an Arabic owner saw NISSAN, CHEVROLET,
     KIA. The brand master carries both spellings for all 108 brands, so it is
     only a matter of picking the one that matches the language. */
  const brandLabel = (brand) =>
    (isRTL ? brand?.nameAr || brand?.name : brand?.name || brand?.nameAr) || '';
  const dispatch = useDispatch();
  const home = useSelector((state) => state?.home);

  const CarBrandList = home?.garageCarBrandList;
  const garageServiceList = home?.GarageServices?.data?.response?.data;
  const GarageCategoryList = home?.garageCategoryList?.response;
  const GarageFilterList = home?.GarageFilterList;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'all' });

  const [slected, setslected] = useState([{ id: '' }]);

  // [CF-GARAGE-2] Service input fields are hidden until the owner clicks
  // "Add New Service". Default false so fields don't show under Manage Services.
  const [showServiceFields, setShowServiceFields] = useState(false);

  const [services, setservices] = useState([
    {
      serviceType: '',
      carBrands: [],
    },
  ]);

  const handleInputAdd = (e, indexValue) => {
    const { name, value } = e.target;
    const list = [...services];
    list[indexValue][name] = value;

    // If serviceType is selected, set the garageService name
    if (name === 'serviceType') {
      const selectedCategory = GarageCategoryList.find(
        (cat) => cat.categoryId === value
      );
      if (selectedCategory) {
        setGarageService(selectedCategory.category); // auto-fill the service name
      }
    }

    setservices(list);
  };

  // useEffect(() => {
  //   if (garageServiceList?.length) {
  //     setservices(
  //       garageServiceList?.map((dt) => {
  //         return {
  //           serviceType: dt?.serviceId,
  //           carBrands: dt?.brands?.map((bd) => bd?.brandId),
  //         };
  //       })
  //     );
  //   }
  // }, [garageServiceList]);

  const [index1, setIndex] = useState('');

  const handleRemoveClick = (index) => {
    const list = [...services];
    list.splice(index, 1);
    setservices(list);
  };

  const handleAddClick = (e) => {
    setservices([
      ...services,
      {
        serviceType: '',
        carBrands: [],
      },
    ]);
  };

  useEffect(() => {
    dispatch(getCarBrand());
    dispatch(getGarageCategory());
    dispatch(getGarageServices());
  }, [dispatch]);

  /* [CF 2026-08-17] Same reload fix as Quick Services: the owner's business id
     is not in sessionStorage yet on a hard refresh — it arrives with
     /business/my a moment later — so fetching once at mount asked for
     `undefined` and the page came up empty. */
  const ownerBid =
    (home?.getMybusiness?.businessId && String(home.getMybusiness.businessId)) ||
    sessionStorage.getItem('BusinessId');

  useEffect(() => {
    if (ownerBid && ownerBid !== 'undefined' && ownerBid !== 'null') {
      dispatch(getGarageDataWFilter(ownerBid));
    }
  }, [dispatch, ownerBid]);

  const ResetHendler = () => {};

  const [garageService, setGarageService] = useState('');
  const [carBrands, setCarBrands] = useState([]);
  const [dataEdit, setDataEdit] = useState({});

  const onEditHandler = (item) => {
    setDataEdit(item);
    /* [CF 2026-08-17 #10] Editing opens a modal, while "Add New Service" opens
       an inline form on the page behind it. With the inline form left open the
       owner saw BOTH at once and could not tell which one they were filling in.
       Starting an edit now closes the add form. */
    setShowServiceFields(false);
  };

  console.log('dataEdit', dataEdit);

  const clearForm = () => {
    setDataEdit({});
    setGarageService('');
    setCarBrands([]);
  };

  // Close the Add/Update Service modal after a successful submit. The modal is
  // opened via legacy data-toggle, so try Bootstrap 5, then jQuery, then a
  // manual DOM teardown as a last resort — whichever is active.
  const closeModal = () => {
    const el = document.getElementById('car-services-add-update');
    if (!el) return;
    try {
      // eslint-disable-next-line global-require
      const { Modal } = require('bootstrap');
      (Modal.getInstance(el) || Modal.getOrCreateInstance(el)).hide();
    } catch (e) {}
    try {
      if (window.$ && window.$(el).modal) window.$(el).modal('hide');
    } catch (e) {}
    setTimeout(() => {
      if (el.classList.contains('show') || el.style.display === 'block') {
        el.classList.remove('show');
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      }
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
      document.querySelectorAll('.modal-backdrop').forEach((b) => b.remove());
    }, 60);
  };

  useEffect(() => {
    if (dataEdit && Object.keys(dataEdit).length > 0) {
      setGarageService(dataEdit?.service);
      setCarBrands(dataEdit?.brands?.map((dt) => dt?.brand?.brandId));
    }
  }, [dataEdit]);

  const onDeleteClickHandler = (item) => {
    // [CF-15] Confirm before deleting (was deleting instantly).
    Swal.fire({
      title: t('Are you sure?'),
      text: t('This item will be permanently deleted.'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: t('Yes, delete it'),
      cancelButtonText: t('Cancel'),
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteService(item?.serviceId));
        // [CF-GARAGE-1] The delete action calls getGarageServices() without
        // dispatch, so the list never refreshes. Re-dispatch the fetch here so
        // the deleted service disappears immediately (after the DELETE lands).
        setTimeout(() => {
          dispatch(getGarageServices());
        }, 800);
      }
    });
  };
  const handleAddBrand = (item) => {
    console.log('as8d98asd', item);
    if (!carBrands.includes(item?.brandId)) {
      setCarBrands([...carBrands, item?.brandId]);
    } else {
      setCarBrands(carBrands?.filter((dt) => dt !== item?.brandId));
    }
  };

  const datasubmit = () => {
    var servicesdata = { services };
    if (garageService !== '' && garageService !== undefined) {
      if (dataEdit && Object.keys(dataEdit).length > 0) {
        const payload = {
          serviceId: dataEdit?.serviceId,
          service: garageService,
          carBrandIds: carBrands,
        };
        dispatch(updateGarageService(payload));
        clearForm();
        closeModal();
      } else {
        const payload = {
          service: garageService,
          carBrandIds: carBrands,
        };

        // console.log('payload', payload);

        dispatch(addGarageService(payload));
        clearForm();
        closeModal();
        // [CF-GARAGE-3] Hide the service input fields and reset them after a
        // successful add so they don't stay visible on screen.
        setShowServiceFields(false);
        setservices([{ serviceType: '', carBrands: [] }]);
      }
    } else {
      alert('Please select a valid service');
    }
  };

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-garages-business',
      label: t('Manage Business'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/sp-garages-services',
      label: t('Manage Services'),
    },
    {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: '/sp-garages-banner',
      label: t('Banner'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: '/sp-garages-working-hours',
      label: t('Manage Working Hours'),
    },
  ];

  console.log(
    'garageServiceList',
    garageService,
    garageServiceList,
    carBrands,
    CarBrandList
  );

  const isPaymentPlanActive = sessionStorage.getItem('paymentPlan');

  console.log('isPaymentPlanActive', isPaymentPlanActive);
  return (
    <div>
      <CommonBusinessHeader
        dataList={GarageFilterList}
        getNameKey="garageName"
      />

      <div className="main-content-area">
        <div className="container">
          <div className="row justify-content-between">
            <Sidebar options={sideBarOpt} />
            <div className="col-12 col-sm-12 col-md-9 col-lg-9">
              <form onSubmit={handleSubmit(datasubmit)}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <h4 className="mb-4">{t('Manage Services')}</h4>
                </div>
                {/* [CF-GARAGE-2] Toggle the service input fields. They stay
                    hidden until the owner clicks "Add New Service". */}
                <div className="row mb-3">
                  <div className="col-12">
                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={() => setShowServiceFields((prev) => !prev)}
                    >
                      {showServiceFields ? t('Cancel') : t('Add New Service')}
                    </button>
                  </div>
                </div>
                {showServiceFields && (
                <div className="row mb-2">
                  <div className="col-12">
                    <button
                      type="button"
                      id="btnAdd-2"
                      className="btn btn-warning"
                      onClick={handleAddClick}
                    >
                      {t('Add more Services')}
                    </button>
                  </div>
                </div>
                )}
                {showServiceFields && services.map((x, indexValue) => {
                  return (
                    <div id="example-2">
                      <div className="row group manage-services-row">
                        <div className="col-12 col-sm-12 col-md-4 mb-2 mb-sm-2 mb-md-0">
                          <label for="service-type" className="sr-only">
                            {t('Service Type')}
                          </label>
                          <select
                            className="form-control"
                            name="serviceType"
                            value={x?.serviceType}
                            onChange={(e) => handleInputAdd(e, indexValue)}
                          >
                            <option value="">{t('Service Type')}</option>
                            {GarageCategoryList !== undefined &&
                            GarageCategoryList.length > 0
                              ? GarageCategoryList.map((x) => {
                                  // console.log(x);
                                  return (
                                    <option value={x?.categoryId}>
                                      {catLabel(x?.category, x?.categoryEn)}
                                    </option>
                                  );
                                })
                              : ''}
                          </select>
                        </div>
                        {/* <div className="col-12 col-sm-12 col-md-4 mb-2 mb-sm-2 mb-md-0">
                          <input
                            type="text"
                            className="form-control"
                            placeholder={t('Enter Garage Service Name')}
                            value={garageService}
                            name="service"
                            onChange={(e) => setGarageService(e.target.value)}
                          />
                        </div> */}

                        <div className="col-12 col-sm-12 col-md-4 mb-2 mb-sm-2 mb-md-0">
                          <a
                            className="btn btn-outline-secondary"
                            href="javascript:void(0);"
                            role="button"
                            data-toggle="modal"
                            data-target="#add-car-brands-modal"
                            // onClick={() => {
                            // 	setIndex(indexValue);
                            // }}
                          >
                            {t('Add Car Brands')}
                          </a>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                          {services.length !== 1 && (
                            <button
                              type="button"
                              className="btn btn-danger btnRemove"
                              onClick={() => handleRemoveClick(indexValue)}
                            >
                              {t('Remove')}
                            </button>
                          )}
                        </div>
                      </div>

                      <div
                        className="modal fade"
                        id="add-car-brands-modal"
                        tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog modal-dialog-scrollable modal-lg">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5
                                className="modal-title"
                                id="exampleModalLabel"
                              >
                                {t('Car Brands')}
                              </h5>
                              <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div className="modal-body">
                              <div className="add-car-brands-wrap">
                                {/* <ul
                                  className="nav nav-pills mb-3"
                                  id="pills-tab"
                                  role="tablist"
                                >
                                  {CarBrandList !== undefined &&
                                  CarBrandList.length > 0
                                    ? CarBrandList.map((item) => {
                                        return (
                                          <li className="nav-item">
                                            <a className="nav-link ">
                                              {item.area}
                                            </a>
                                          </li>
                                        );
                                      })
                                    : ''}
                                </ul> */}
                                <div className="tab-content">
                                  <div className="tab-pane fade show active nav-item">
                                    <div className="row ">
                                      {CarBrandList !== undefined &&
                                      CarBrandList.length > 0
                                        ? CarBrandList?.map((item, index) => {
                                            // console.log(
                                            //   'carbrands ',
                                            //   carBrands?.includes(item?.brandId)
                                            // );
                                            return (
                                              <div
                                                className={`col-6 col-sm-6 col-md-2 mb-4 `}
                                              >
                                                <div
                                                  className="car-brands-block"
                                                  name="carBrands"
                                                  // id={indexValue}
                                                  onClick={() =>
                                                    handleAddBrand(item)
                                                  }
                                                >
                                                  <div
                                                    className="car-brands-a "
                                                    style={{ color: 'yellow' }}
                                                    name="carBrands"
                                                    // id={indexValue}
                                                    // value={x.carBrands}
                                                  >
                                                    <img
                                                      style={{
                                                        border:
                                                          carBrands?.includes(
                                                            item?.brandId
                                                          )
                                                            ? '2px solid orange'
                                                            : '',
                                                        borderRadius: '5px',
                                                      }}
                                                      src={item?.media?.path}
                                                      className="img-fluid "
                                                      alt=""
                                                      onError={(e) => {
                                                        e.target.src =
                                                          'assets/images/car-brands/all.jpg';
                                                      }}
                                                    />
                                                  </div>

                                                  <div className="car-brands-b nav-item">
                                                    {/* [CF 2026-08-17] Was `NAME (nameAr)` - both spellings at once. Show the one that matches the site language. */}
                                                    {brandLabel(item)}
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          })
                                        : ''}
                                      <hr />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-primary "
                                data-dismiss="modal"
                              >
                                {t('Submit')}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* ADD OR UPDATE SERVICE MODAL — kept outside the (toggle-gated)
                    service-fields map so editing a saved service still opens it. */}
                <div
                  className="modal fade"
                  id="car-services-add-update"
                  tabindex="-1"
                  aria-labelledby="addModualUpdate"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-scrollable modal-lg">
                    <div
                      className="modal-content"
                      style={{ height: 'fit-content' }}
                    >
                      <div className="modal-header">
                        <h5 className="modal-title" id="addModualUpdate">
                          {t('Add Car Brands')}
                        </h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="add-car-brands-wrap">
                          <div className="tab-content">
                            <div className="tab-pane fade show active nav-item">
                              <label>{t('Business Service Name')}</label>
                              <div className="col-12 col-sm-12 col-md-4 mb-2 mb-sm-2 mb-md-0">
                                <label for="service-type" className="sr-only">
                                  {t('Service Type')}
                                </label>
                                <select
                                  className="form-control"
                                  name="serviceType"
                                  value={dataEdit?.service}
                                  onChange={(e) =>
                                    setDataEdit({
                                      ...dataEdit,
                                      service: e.target.value,
                                    })
                                  }
                                >
                                  <option value="">{t('Service Type')}</option>
                                  {GarageCategoryList !== undefined &&
                                  GarageCategoryList.length > 0
                                    ? GarageCategoryList.map((x) => {
                                        // console.log(x);
                                        return (
                                          <option value={x?.category}>
                                            {catLabel(x?.category, x?.categoryEn)}
                                          </option>
                                        );
                                      })
                                    : ''}
                                </select>
                              </div>
                              <div className="services-container">
                                {CarBrandList?.map((cb, inde) => (
                                  <div
                                    key={inde}
                                    className={`map-card ${
                                      carBrands.includes(cb?.brandId)
                                        ? 'active'
                                        : ''
                                    } `}
                                    onClick={() => handleAddBrand(cb)}
                                  >
                                    <img src={cb?.media?.path} alt="" />
                                    <span>{cb?.name}</span>
                                  </div>
                                ))}
                              </div>
                              <footer className="form-footer">
                                <button
                                  type="submit"
                                  // to='/sp-garages-packages'
                                  className="btn btn-warning btn-block"
                                  // href='sp-garages-manage-business-packages.html'
                                  // role='button'
                                >
                                  {t('Update')}
                                </button>
                                {carBrands.length > 0 && (
                                  <span>
                                    {carBrands.length} {t('Brands Selected')}
                                  </span>
                                )}
                              </footer>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* [FB2-#9c] Rebuilt saved-service list as polished branded
                    cards (same design as quick-services). Layout is INLINE-flex
                    so the Edit/Delete icon buttons can never overlap the service
                    name or the supported-vehicle chips. */}
                <div className="row" id="service-container">
                  {garageServiceList?.map((dt, ind) => (
                    <div className="col-12 col-lg-6 mb-3" key={ind}>
                      <div className="qs-svc-card">
                        <span className="qs-svc-accent" aria-hidden="true" />
                        <div
                          style={{ flex: 1, minWidth: 0, padding: '14px 16px' }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              justifyContent: 'space-between',
                              gap: '10px',
                            }}
                          >
                            <div
                              style={{
                                fontWeight: 700,
                                fontSize: '1.02rem',
                                color: '#1d2229',
                                minWidth: 0,
                                overflowWrap: 'anywhere',
                              }}
                            >
                              {dt?.service}
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                gap: '8px',
                                flexShrink: 0,
                              }}
                            >
                              <button
                                type="button"
                                className="qs-icon-btn qs-icon-edit"
                                title={t('Edit')}
                                aria-label={t('Edit')}
                                onClick={() => onEditHandler(dt)}
                                data-toggle="modal"
                                data-target="#car-services-add-update"
                              >
                                <i className="far fa-edit"></i>
                              </button>
                              <button
                                type="button"
                                className="qs-icon-btn qs-icon-del"
                                title={t('Delete')}
                                aria-label={t('Delete')}
                                onClick={() => onDeleteClickHandler(dt)}
                              >
                                <i className="far fa-trash-alt"></i>
                              </button>
                            </div>
                          </div>
                          {dt?.brands?.length > 0 && (
                            <>
                              <div
                                style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: '6px',
                                }}
                              >
                                {dt?.brands?.map((bd, inde) => {
                                  const brand = bd?.brand || bd;
                                  return (
                                    <span className="qs-chip" key={inde}>
                                      {brandLabel(brand)}
                                    </span>
                                  );
                                })}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {/* <!-- Add Car Brands --> */}

                {showServiceFields && (
                <div className="row mt-5 ">
                  {/* <div className="col-6">
                    <button
                      type="reset"
                      onClick={ResetHendler}
                      className="btn btn-secondary btn-block"
                      href="#"
                      // onClick={ResetHendler}
                      // role='button'
                    >
                      {t('Reset')}
                    </button>
                  </div> */}
                  <div className="col-6">
                    <button
                      type="submit"
                      // to='/sp-garages-packages'
                      className="btn btn-warning btn-block"
                      // href='sp-garages-manage-business-packages.html'
                      // role='button'
                    >
                      {t('Submit')}
                    </button>
                    {/* {isPaymentPlanActive == 'true' ? (
                    ) : (
                      <a
                        class="btn btn-warning btn-block"
                        href="#/manage-package"
                        role="button"
                      >
                        Buy Subscription
                      </a>
                    )} */}
                  </div>
                </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GaragesServices;
